export const CATEGORIES = {
  SMARTPHONE: 'smartphone',
  AUDIO: 'audio',
  MACBOOK: 'macbook',
  CONSOLE: 'gaming_console',
  TABLET: 'tablet',
}
